// Maps a user's assigned (spend) verticals onto the Targets taxonomy so we can
// decide whether a vertical lead has any applicable targets to show.
export const TARGET_VERT_MAP = {
  ATL: "ATL/BTL",
  BTL: "ATL/BTL",
  "ATL/BTL": "ATL/BTL",
  Digital: "Digital",
  "Digital Support": "Digital",
  "Digital Marketing": "Digital",
  CX: "CX",
  CXX: "CX",
};

export function targetVerticalsFor(assigned = []) {
  const s = new Set();
  (assigned || []).forEach((v) => {
    const t = TARGET_VERT_MAP[(v || "").trim()];
    if (t) s.add(t);
  });
  return Array.from(s);
}

// A vertical lead has targets only if at least one assigned vertical maps onto
// the Targets taxonomy (ATL/BTL, Digital, CX).
export function hasTargets(assigned = []) {
  return targetVerticalsFor(assigned).length > 0;
}
